import React from "react";
import { ChartBar, Hotel, Users, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Solar Energy Harvesting",
  description: "High-performance solar arrays utilizing premium Victron and Enerdrive components designed for maximum off-grid reliability in harsh Australian conditions.",
  icon: Hotel
}, {
  title: "Lithium Storage Systems",
  description: "Advanced battery management systems (BMS) and lithium upgrades that provide consistent power for your caravan's appliances for days on end.",
  icon: ChartBar
}, {
  title: "Generator Integration",
  description: "Expert installation of onboard generator systems with automatic transfer switching and professional acoustic dampening for quiet, efficient operation.",
  icon: Users
}, {
  title: "Smart Power Monitoring",
  description: "Full-system digital integration with intuitive displays and smartphone connectivity to monitor your energy harvesting and storage levels in real-time.",
  icon: TrendingUp
}];
export default function OurConsultingServicesForCreteco() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="25092" id="our-solar-battery-generator-services" ref={ref} className="bg-background py-[120px] overflow-hidden text-foreground">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {}
          <div className={cn("lg:col-span-6 transition-all duration-1000 ease-out delay-200", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
            <div className="relative w-full h-[600px] rounded-xl overflow-hidden shadow-xl border border-border">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599594/img/creteco_architectural_detail.png" alt="Professional caravan solar and battery management system installation" className="w-full h-full object-cover grayscale-[20%]" />
            </div>
          </div>

          {}
          <div className={cn("lg:col-span-6 flex flex-col gap-10 transition-all duration-1000 ease-out delay-400", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
            <h2 className="font-sans font-extrabold text-[40px] leading-tight text-primary tracking-tighter uppercase">
              Advanced Power Solutions
            </h2>

            <div className="flex flex-col gap-8">
              {services.map((service, i) => <div key={i} data-index={i} className="group flex gap-6 p-4 rounded-xl transition-all duration-300 ease-[cubic-bezier(0.25,0.1,0.25,1)] hover:-translate-y-1 hover:bg-secondary/5 hover:shadow-md border border-transparent hover:border-border">
                  <div className="shrink-0 pt-1">
                    <service.icon className="w-6 h-6 text-secondary" />
                  </div>
                  <div className="flex flex-col gap-2">
                    <h3 className="font-sans text-[20px] font-bold text-primary tracking-tight">
                      {service.title}
                    </h3>
                    <p className="font-sans text-[16px] leading-relaxed text-primary/70">
                      {service.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}